import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const SegmentedControlButton = ({
	title,
	onPress,
  active,
}) => (
	<button
		className={`button-segmented-control ${active ? 'button-segmented-control_active' : ''}`}
		onClick={onPress}
	>
		{title}
	</button>
);

SegmentedControlButton.propTypes = {
	title: PropTypes.string.isRequired,
	onPress: PropTypes.func,
  active: PropTypes.bool,
};

SegmentedControlButton.defaultProps = {
	onPress: () => {},
  active: false,
};

export default SegmentedControlButton;



// WEBPACK FOOTER //
// ./src/components/ui/Buttons/SegmentedControlButton/index.js